import { Chip } from "@mui/material";
import { useUrlFilterTags } from "hooks/filterHooks";
import { FrontendFilterTag } from "types/types";

interface Props {
  tag: FrontendFilterTag;
}
export default function FilterChip(props: Props) {
  const { tag } = props;
  const { tagIds, updateTags } = useUrlFilterTags();
  const isActive = tagIds.includes(tag.id);

  function toggleTagFilter(tagId: number) {
    updateTags(tagId);
  }

  return (
    <Chip
      label={tag.name}
      onClick={() => toggleTagFilter(tag.id)}
      color={isActive ? "primary" : undefined}
    />
  );
}
